// SA-3
import type { ScheduleSlotRecord, TimesheetEntryRecord } from '../types/records'

/** Активный слот на станке в интервале дня/смены (предпочтение in_progress). */
export function findScheduleSlotForMachine(
  machineId: string,
  shiftId: string,
  workDate: string,
  slots: ScheduleSlotRecord[],
): ScheduleSlotRecord | null {
  const dayStart = `${workDate} 00:00:00`
  const dayEnd = `${workDate} 23:59:59`
  const candidates = slots.filter((s) => {
    if (s.machine !== machineId) return false
    if (shiftId && s.shift && s.shift !== shiftId) return false
    if (s.status === 'cancelled') return false
    return s.plannedStart <= dayEnd && s.plannedEnd >= dayStart
  })
  candidates.sort((a, b) => {
    if (a.status === 'in_progress' && b.status !== 'in_progress') return -1
    if (b.status === 'in_progress' && a.status !== 'in_progress') return 1
    return new Date(a.plannedStart).getTime() - new Date(b.plannedStart).getTime()
  })
  return candidates[0] ?? null
}

/** Другой присутствующий сотрудник уже назначен на этот станок в смену. */
export function machineOccupiedByOther(
  machineId: string,
  workerId: string,
  entries: TimesheetEntryRecord[],
): TimesheetEntryRecord | null {
  for (const e of entries) {
    if (!e.present) continue
    if (e.machine !== machineId) continue
    const wid = typeof e.worker === 'string' ? e.worker : ''
    if (wid && wid !== workerId) return e
  }
  return null
}

export function suggestDefaultMachineId(
  worker: { defaultMachine?: string | null },
  shiftId: string,
  workDate: string,
  slots: ScheduleSlotRecord[],
): string {
  const dm = worker.defaultMachine?.trim()
  if (!dm) return ''
  const slot = findScheduleSlotForMachine(dm, shiftId, workDate, slots)
  if (slot && slot.status === 'in_progress') return dm
  return dm
}
